import { buildElationUrlPrescribe } from '@seen/core/elation'
import { Participant } from '@seen/core/models/patients/participant'
import { useCallback } from 'react'
import { useConfig } from '#src/contexts/config/useConfig.ts'
import { useRead } from '#src/hooks/useRead.ts'

export interface UseElationPrescribeResult {
  openPrescribe: () => void
  prescribeUrl: string | undefined
  canPrescribe: boolean
  isLoading: boolean
}

export function useElationPrescribe(
  patientId: string | undefined
): UseElationPrescribeResult {
  const { elationBaseUrl } = useConfig()
  const { data: participant, isLoading } = useRead(Participant, patientId)

  const elationPatientId = participant?.elationId
  const prescribeUrl =
    elationPatientId !== undefined
      ? buildElationUrlPrescribe({ elationBaseUrl, elationPatientId })
      : undefined

  const openPrescribe = useCallback(() => {
    if (prescribeUrl) {
      window.open(prescribeUrl, '_blank', 'noopener,noreferrer')
    }
  }, [prescribeUrl])

  return {
    openPrescribe,
    prescribeUrl,
    canPrescribe: elationPatientId !== undefined,
    isLoading,
  }
}
